export function isAnyFocused(): boolean {
  const { activeElement } = window.document;

  if (!activeElement) {
    return false;
  }

  const isPowerSelectFocused = activeElement.classList.contains(
    'ember-power-select-trigger',
  );

  const isItiFocused = activeElement.classList.contains('iti__search-input');

  const isModalFocused = activeElement.classList.contains('modal-content');

  const isInputFocused = ['INPUT', 'TEXTAREA'].includes(activeElement.tagName);

  return [
    isPowerSelectFocused,
    isItiFocused,
    isModalFocused,
    isInputFocused,
  ].some(Boolean);
}
